import { TableCell, TableRow } from "@/components/ui/table";
import { Table, flexRender } from "@tanstack/react-table";
import { SubscriptionColumn } from "../../assets/SubscriptionColumns";
import { SubscriptionTable } from "../../types/subscriptions.type";

interface Props<TData> {
  table: Table<TData>;
  columns: SubscriptionColumn[];
}

export function SubscriptionsTableContent<TData extends SubscriptionTable>({
  table,
  columns
}: Props<TData>) {
  return table.getRowModel().rows.length ? (
    table.getRowModel().rows.map((row) => (
      <TableRow data-testid="subscriptionRow" className="h-16" key={row.id}>
        {row.getVisibleCells().map((cell) => (
          <TableCell
            className="first:w-16 first:min-w-16 last:w-10"
            key={cell.id}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        ))}
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={columns.length} className="h-16 text-center">
        No subscriptions found
      </TableCell>
    </TableRow>
  );
}
